export default __webpack_public_path__ + "static/media/Sign-in-Dark-personal.66ca9c91.svg";